import React, { FC } from 'react';
import { IMeetingConfirmation, IUser } from '@utils';
import { MemberChip } from './MemberChip';

interface MembersChipListProp {
  meetingMembers: IUser[];
  initiatorId: number;
  listOpen: boolean;
  readOnly: boolean;
  setListOpen: (arg: boolean) => void;
  onDeleteMember: (userId: number) => void;
  confirmations: IMeetingConfirmation[];
}

export const MembersChipList: FC<MembersChipListProp> = ({
  meetingMembers, initiatorId, listOpen, setListOpen, 
  onDeleteMember, readOnly, confirmations
}) => {

  return (
    <>
      {meetingMembers.map((member: IUser, index) => (
        ((listOpen || index <= 4) && member) && (
          <MemberChip // TODO:ЗДЕСЬ ПРОВЕРКА НА УВОЛЕННОГО СОТРУДНИКА
            key={member.id}
            member={member}
            isCloseList={meetingMembers.length === 6}
            readOnly={readOnly}
            initiatorId={initiatorId}
            setListOpen={setListOpen}
            onDeleteMember={onDeleteMember}
            confirmations={confirmations}
          />
        )
      ))}
    </>
  );
};
